export default __webpack_public_path__ + "static/media/arrow.cb3d0542.svg";